import { render, staticRenderFns } from "./PostcodeInput.vue?vue&type=template&id=b68c6676&scoped=true"
import script from "./PostcodeInput.vue?vue&type=script&lang=js"
export * from "./PostcodeInput.vue?vue&type=script&lang=js"
import style0 from "./PostcodeInput.vue?vue&type=style&index=0&id=b68c6676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c6676",
  null
  
)

export default component.exports